import { Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  CardStakeholderBox,
  DescriptionTypography,
  ImageBox,
  TextContent,
  TitleTypography
} from "./StakeholderCard.styles";

// eslint-disable-next-line import/no-unresolved
import { Stakeholder } from "../../../types";

export function StakeholderCard({ stakeholder }: {stakeholder: Stakeholder}) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CardStakeholderBox
      container
      gap={ 3 }
    >
      <ImageBox
        image={ stakeholder.imageProfile ?? "" }
      >
        { stakeholder.imageProfile ?
          <img src={ stakeholder.imageProfile } alt="card teacher"/> :
          <Typography
            fontWeight={ 700 }
            fontSize={ isMobile ? "2rem" : "4rem" }
            height={ "fit-content" }
            margin={ "auto" }
            color={ "#333" }
          >
            { stakeholder.name?.split(" ").map(i => i.charAt(0)).toString().toUpperCase().split(",") }
          </Typography>
        }
      </ImageBox>
      <TextContent>
        <TitleTypography>
          { stakeholder.name }
        </TitleTypography>
        <DescriptionTypography>
          { stakeholder.type }
        </DescriptionTypography>
      </TextContent>
    </CardStakeholderBox>
  );
}
